export default function Notifications() {
  return (
    <div className="h-screen lg:w-1/2 w-full flex justify-center items-center">
      Proximamente
    </div>
  );
}
